
export default function HeroSection() {
  return (
    <section className="relative h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 600'%3E%3Crect fill='%232A7A62' width='1920' height='600'/%3E%3C/svg%3E"
          alt="志愿者活动海报"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-center justify-center text-center px-4 md:px-6 z-10">
        <div className="max-w-4xl">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">
            加入我们，传递温暖
          </h1>
          <p className="text-base md:text-xl text-white/90 mb-6 md:mb-8 leading-relaxed px-2">
            成为点滴公益志愿者，用您的时间和热情，为一线工作者送去关怀
            <br className="hidden md:block" />
            <span className="md:hidden"> </span>
            每一份付出，都将汇聚成改变的力量
          </p>
          <div className="flex items-center justify-center gap-6 md:gap-12 text-white">
            <div>
              <div className="text-2xl md:text-4xl font-bold text-[#F4B942]">328</div>
              <div className="text-xs md:text-sm mt-1 md:mt-2 opacity-90">注册志愿者</div>
            </div>
            <div className="w-px h-8 md:h-12 bg-white/30"></div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-[#F4B942]">12,450</div>
              <div className="text-xs md:text-sm mt-1 md:mt-2 opacity-90">服务时长（小时）</div>
            </div>
            <div className="w-px h-8 md:h-12 bg-white/30"></div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-[#F4B942]">89</div>
              <div className="text-xs md:text-sm mt-1 md:mt-2 opacity-90">公益活动</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
